import React, { useState } from 'react';
import { Input, Label, Modal } from 'reactstrap';
import modalclose from '../../../images/close1.png';
import './index.css';
import { handleErrorMessage } from '../../../utils/utils';
import ModalService from '../../../services/ModalService';

const PartiallyAcceptOrderConfirmModal = ({
  isOpen,
  toggle,
  rejectOrder,
  title,
}) => {
  const [selectedOption, setSelectedOption] = useState('Credit limit exceeded');
  const [otherReason, setOtherReason] = useState('');

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      id="PartiallyAcceptOrderConfirmModal"
    >
      <div className="modalHeader mb-0">
        <div className="title">{title || 'Reject Order'}</div>
        <div className="closeButton">
          <img src={modalclose} alt="close" onClick={toggle} />
        </div>
      </div>
      <div className="modalBody">
        <div>
          <Label htmlFor="reason">
            Reason<strong style={{ color: 'blue' }}>*</strong>
          </Label>
          <select
            id="reason"
            className="acceptReason"
            placeholder="Select"
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            <option value="Credit limit exceeded">Credit limit exceeded</option>
            <option value="Stock not available">Stock not available</option>
            <option value="Other">Other</option>
          </select>
        </div>
        {selectedOption === 'Other' && (
          <div>
            <Label htmlFor="packageAmount">
              Reason<strong style={{ color: 'blue' }}>*</strong>
            </Label>
            <Input
              name="reason"
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
              autoComplete="off"
              type="text"
              placeholder="Reason"
              id="reason"
            />
          </div>
        )}
      </div>
      <div className="modalBottom">
        <button
          className="customButton customButton_blue"
          onClick={() => {
            if (selectedOption === 'Other' && !otherReason) {
              ModalService.openAlert(
                '',
                handleErrorMessage('Enter all required fields'),
                'error',
              );
              return;
            }
            rejectOrder(
              selectedOption === 'Other' ? otherReason : selectedOption,
            );
          }}
        >
          Submit
        </button>
      </div>
    </Modal>
  );
};

export default PartiallyAcceptOrderConfirmModal;
